import React from "react";

import { IgCheckbox } from "@intelligems/ig-theme/IgCheckbox";
import { GenericFlexStartContainer } from "@src/components/MainApp/SharedProductPicker/list/containers";
import { useDispatch, useSelector } from "@src/store";
import { getProductPickerData } from "@src/store/slices/productPicker";
import { getProductPickerSelectionType } from "@src/store/slices/productPicker/selectors/getProductPickerSelectionType";
import { toggleSelectAll } from "@src/store/slices/productPicker/thunks/toggleSelectAll";

export const ProductHeaderCheckBox = () => {
  const type = useSelector(getProductPickerSelectionType);
  const data = useSelector(getProductPickerData);
  const dispatch = useDispatch();

  return (
    <GenericFlexStartContainer>
      {data?.type !== "gwp" && data?.type !== "checkoutUpsellProductAction" && (
        <IgCheckbox
          checked={type === "all"}
          indeterminate={type === "partial"}
          onClick={() => void dispatch(toggleSelectAll())}
        />
      )}
    </GenericFlexStartContainer>
  );
};
